import {
  BankOutlined,
  HomeOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
  CopyOutlined,
  PaperClipOutlined,
  CarryOutFilled,
  CarryOutOutlined,
} from "@ant-design/icons";
import { message, Spin, Tag, Tooltip } from "antd";
import { useAdmin } from "../../../context/adminContext";
import { useEffect, useState } from "react";
import GetMerchant from "../../../functions/admin/getMerchant";
import { bg_shadow, bg_text } from "constant/css";

const MerchantInfo = () => {
  const { activeMerchantId } = useAdmin();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (activeMerchantId) fetchMerchantInfo();
  }, [activeMerchantId]);

  const fetchMerchantInfo = async () => {
    setLoading(true);
    const response = await GetMerchant(activeMerchantId);
    if (response.success) {
      setData(response.data);
    }
    setLoading(false);
  };

  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    message.success("Хуулсан: " + text);
  };

  if (loading || !data)
    return (
      <Spin size="large" className="block mx-auto my-10 custom-green-spin" />
    );

  return (
    <div className={`rounded-2xl p-6 bg-white  text-gray-800`}>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-y-4 text-sm font-medium">
        <div className="flex gap-2 items-center">
          <MailOutlined />
          Имэйл: {data.email || "—"}
          <Tooltip title="Хуулах" placement="top">
            <CopyOutlined
              className="cursor-pointer"
              onClick={() => copyToClipboard(data.email)}
            />
          </Tooltip>
        </div>
        <div className="flex gap-2 items-center">
          Байгууллагын регистр: {data.register || "—"}
          <Tooltip title="Хуулах" placement="top">
            <CopyOutlined
              className="cursor-pointer"
              onClick={() => copyToClipboard(data.register)}
            />
          </Tooltip>
        </div>
        <div className="flex gap-2 items-center">
          <PhoneOutlined />
          Утас 1: {data.phone || "—"}
          <Tooltip title="Хуулах" placement="top">
            <CopyOutlined
              className="cursor-pointer"
              onClick={() => copyToClipboard(data.phone)}
            />
          </Tooltip>
        </div>
        <div className="flex gap-2 items-center">
          Утас 2: {data.phone2 || "—"}
          <Tooltip title="Хуулах" placement="top">
            <CopyOutlined
              className="cursor-pointer"
              onClick={() => copyToClipboard(data.phone2)}
            />
          </Tooltip>
        </div>
        <div className="flex gap-2 items-center sm:col-span-1">
          <HomeOutlined />
          Байршил: {data.address || "—"}
          <Tooltip title="Хуулах" placement="top">
            <CopyOutlined
              className="cursor-pointer"
              onClick={() => copyToClipboard(data.address)}
            />
          </Tooltip>
        </div>
        <div className="flex gap-2 items-center sm:col-span-1">
          <CarryOutOutlined />
          Багц: <Tag color="cyan">{data.pack || "—"}</Tag>
          <Tooltip title="Хуулах" placement="top">
            <CopyOutlined
              className="cursor-pointer"
              onClick={() => copyToClipboard(data.address)}
            />
          </Tooltip>
        </div>
        <div className="flex gap-2 items-center sm:col-span-2">
          <BankOutlined />
          Банк:
          <span className={`${bg_text}`}>
            {data.accountNumber || "—"} ({data.bankCode || "—"})
          </span>
          <Tooltip title="Хуулах" placement="top">
            <CopyOutlined
              className="cursor-pointer"
              onClick={() =>
                copyToClipboard(
                  `${data.accountNumber || ""} (${data.bankCode || ""})`
                )
              }
            />
          </Tooltip>
        </div>
        <div className="sm:col-span-2 flex flex-wrap items-center gap-2 mt-2">
          <Tag color="cyan" className="text-sm">
            Төлбөрийн шимтгэл: {data.feePercent}%
            <Tooltip title="Хуулах" placement="top">
              <CopyOutlined
                className="cursor-pointer ml-1"
                onClick={() => copyToClipboard(`${data.feePercent}%`)}
              />
            </Tooltip>
          </Tag>
          <Tag color="cyan" className="text-sm">
            xPay шимтгэл: {data.spayFeePercent}%
            <Tooltip title="Хуулах" placement="top">
              <CopyOutlined
                className="cursor-pointer ml-1"
                onClick={() => copyToClipboard(`${data.spayFeePercent}%`)}
              />
            </Tooltip>
          </Tag>
          <Tag color="cyan" className="text-sm">
            Хэрэглэгч шимтгэл: {data.userFee}
            {data.userFeeType === "PERCENT" ? "%" : "₮"}
            <Tooltip title="Хуулах" placement="top">
              <CopyOutlined
                className="cursor-pointer ml-1"
                onClick={() =>
                  copyToClipboard(
                    `${data.userFee}${
                      data.userFeeType === "PERCENT" ? "%" : "₮"
                    }`
                  )
                }
              />
            </Tooltip>
          </Tag>
        </div>
      </div>
    </div>
  );
};

export default MerchantInfo;
